export default {
  loading: 'Loading...',
  failed: 'Search unavailable',
  changeCountry: 'Change country',
};
